import { all, Effect, fork, put, select, takeLatest } from 'redux-saga/effects';
import type { ApplicationState } from '../types';
import { changeCurrentOrganisationAction, setCurrentOrganisationAction } from './actions';

export function* handleChangeCurrentOrganisation(
  action: ReturnType<typeof changeCurrentOrganisationAction>,
): Generator<Effect> {
  const user = (yield select(
    (state: ApplicationState) => state.authenticatedUser.current,
  )) as ApplicationState['authenticatedUser']['current'];

  const nextOrganisation = user?.organisations.find(({ slug }) => slug === action.payload.slug);

  if (!nextOrganisation) {
    yield put(setCurrentOrganisationAction({ current: undefined }));
    return;
  }

  yield put(setCurrentOrganisationAction({ current: nextOrganisation }));
}

function* watchChangeCurrentOrganisation() {
  yield takeLatest(changeCurrentOrganisationAction, handleChangeCurrentOrganisation);
}

export function* organisationSagas(): Generator<Effect> {
  yield all([fork(watchChangeCurrentOrganisation)]);
}
